import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-population-modelling',
  templateUrl: './population-modelling.component.html',
  styleUrls: ['./population-modelling.component.scss']
})
export class PopulationModellingComponent implements OnInit {

  information: CardContent = {
    title: 'Age-structured Population',
    sections: [
      `Contact rates are generally not homogeneously distributed within
      a population. The contact matrix to the right illustrates that
      contacts within a population are highly asortative by age and
      dominated by contacts between children of the same age at school.
      To reflect this observation, our models are stratified by age,
      using up to 100 age groups. The animation at right shows the
      effective contact matrix of an individual-based stochastic
      simulation for an aging population over a period of 60 years.`
      ,
    ]
  };

  exposition: CardContent = {
    title: 'Population Modelling',
    subtitle: 'Animation of simulated contact matrices 1992-2052',
    image_source: 'assets/images/Figure 9-Simulated 1992-2052.gif',
  };



  constructor() { }

  ngOnInit(): void {
  }

}
